import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from 'Components/UI/Typography';
import Button from 'Components/UI/Button';
import closeModal from 'Helpers/ModalHelper';
import { withStyles } from '@material-ui/core/styles';
import LoadingOverlay from 'Components/UI/LoadingOverlay/LoadingOverlay';
import TextField from 'Components/UI/TextField';

const styles = theme => ({
  root: {},
  dialogPaper: {
    width: '100%',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.facet.darkGray,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const InvestigationAppealModal = ({
  classes, onClose, onSubmit, defaultText, prompt, isLoading,
}) => {
  const [text, setText] = React.useState(defaultText || '');

  return (
    <Dialog
      classes={{
        root: classes.root,
        paper: classes.dialogPaper,
      }}
      maxWidth="sm"
      open
      onClose={closeModal}
    >
      {isLoading && <LoadingOverlay />}
      <DialogTitle>
        <Typography
          className={classes.title}
        >
          {`${prompt} Investigation`}
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <TextField
          value={text}
          onChange={e => setText(e.target.value)}
          label="Message"
          multiline
          rows={4}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(e) => {
            e.preventDefault();
            onClose();
          }}
          color="primary"
        >
          {'Cancel'}
        </Button>
        <Button
          onClick={() => onSubmit(text)}
          disabled={text === ''}
        >
          {`Submit ${prompt}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

InvestigationAppealModal.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  defaultText: PropTypes.string.isRequired,
  prompt: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};
InvestigationAppealModal.defaultProps = {
  isLoading: false,
};

export default withStyles(styles)(InvestigationAppealModal);
